interface FilterProps {
  style?: React.CSSProperties;
  onClick?: () => void;
  stroke?: string;
}

const Filter = ({ style, onClick, stroke = "#1D1F22" }: FilterProps) => {
    return (
        <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            style={style}
            onClick={onClick}
        >
            <path 
                d="M4.5 7H19.5M7 12H17M10 17H14" 
                stroke={stroke}
                strokeWidth="1.5" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Filter;
